import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.LoginPage.LoginForm', {
    email: 'Email',
    password: 'Password',
    enterEmail: 'Enter your email address',
    enterPassword: 'Enter your password',
    submit: 'Log in',
    emailInvalid: 'The email address is not valid.',
    emailRequired: 'Email is required.',
    passwordRequired: 'Password is required.',
    forgotPassword: 'Forgot your password?',
    loginWithLabel: 'Or login with',
});
